import { FC, ReactElement, useContext } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { DictContext } from "@/layout/context/DictContext";
import { CellSelectWrap } from "./style";
import SText from "@/styles/SText";

interface CreditLevelSelectProps {
  value?: string;
  onChange?: (value: string) => Promise<void>;
  readOnly?: boolean;
}

const CreditLevelSelect: FC<CreditLevelSelectProps> = ({
  value,
  onChange,
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const { creditLevels } = useContext(DictContext);

  if (readOnly) {
    return <SText text={creditLevels.find(item => item.key === value)?.desc ?? value ?? ''} />;
  }

  const getEle: (readOnly: boolean) => ReactElement = (readOnly) => {
    return (
      <CellSelectWrap style={{ flex: 1 }}>
        <Select
          disabled={readOnly}
          value={value}
          onChange={onChange}
          style={{ width: "100%" }}
          placeholder={t("components.plCreditLevel")}
          options={creditLevels}
          fieldNames={{ label: "desc", value: "key" }}
          popupMatchSelectWidth={false}
        />
      </CellSelectWrap>
    );
  };

  return getEle(readOnly);
};

export default CreditLevelSelect;
